import { useStyles } from '~/Screens/Calendar/CalendarView/components/DraggableEvent/DraggableEvent.styles';
import cn from 'classnames';
import React from 'react';
import { Skeleton } from '@mui/material';

export const CalendarSkeletonEvent = () => {
  const { classes } = useStyles();

  return (
    <section className={cn(classes.container)} data-testid="calendarskeletonevent-skeleton">
      <div
        className={cn(classes.container)}
        style={{
          transform: `translate3d(0px, 712px, 0px)`,
          position: 'absolute',
        }}
      >
        <Skeleton variant="rounded" height={64} width={107} style={{ marginBottom: 10 }} />
        <Skeleton variant="rounded" height={64} width={107} />
      </div>
      <div
        className={cn(classes.container)}
        style={{
          transform: 'translate3d(117px, 712px, 0px)',
          position: 'absolute',
        }}
      >
        <Skeleton variant="rounded" height={344} width={107} />
      </div>
      <div
        className={cn(classes.container)}
        style={{
          transform: 'translate3d(566px, 712px, 0px)',
          position: 'absolute',
        }}
      >
        <Skeleton variant="rounded" height={192} width={107} />
      </div>
      <div
        className={cn(classes.container)}
        style={{
          transform: 'translate3d(343px, 583px, 0px)',
          position: 'absolute',
        }}
      >
        <Skeleton variant="rounded" height={32} width={107} style={{ marginBottom: 10 }} />
        <Skeleton variant="rounded" height={32} width={107} />
      </div>
    </section>
  );
};
